import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { "nav-title": "" }
const _hoisted_2 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_3 = {
  key: 0,
  style: {"margin-right":"10px"}
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { "App-User-Profile-Top": "" }
const _hoisted_7 = {
  key: 0,
  class: "App-Talent-T-B",
  success: ""
}
const _hoisted_8 = {
  success: "",
  "f-w-600": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_app_bottom_nav = _resolveComponent("app-bottom-nav")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_biddingCreateModal = _resolveComponent("biddingCreateModal")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_app_user_top_profile = _resolveComponent("app-user-top-profile")!
  const _component_app_user_section = _resolveComponent("app-user-section")!
  const _component_app_user_skills = _resolveComponent("app-user-skills")!
  const _component_app_user_education = _resolveComponent("app-user-education")!
  const _component_app_user_experience = _resolveComponent("app-user-experience")!
  const _component_app_business_right_nav = _resolveComponent("app-business-right-nav")!
  const _component_app_opportunities_list_nav = _resolveComponent("app-opportunities-list-nav")!
  const _component_app_right_nav = _resolveComponent("app-right-nav")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!
  const _directive_blur = _resolveDirective("blur")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_app_main_layout, { class: "User-Page" }, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    "bottom-nav": _withCtx(() => [
      _createVNode(_component_app_bottom_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: false }, _createSlots({
        left: _withCtx(() => [
          false
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                plain: "",
                circle: "",
                "is-all-borderless": "",
                icon: "el-icon-back"
              }))
            : _createCommentVNode("", true)
        ]),
        center: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_ctx.talent)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_ctx.talent.firstName) + "'s ", 1)
                ])), [
                  [_directive_blur, _ctx.talent]
                ])
              : _createCommentVNode("", true),
            _cache[0] || (_cache[0] = _createElementVNode("span", { style: {"padding-left":"6px"} }, " Profile", -1))
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        _: 2
      }, [
        (_ctx.talent)
          ? {
              name: "right",
              fn: _withCtx(() => [
                (_ctx.hasAlreadyBidded === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_el_tag, {
                        type: "warning",
                        "is-rounded": ""
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" Sent Bid ", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : (
              _ctx.hasAlreadyBidded === false && _ctx.talent.availableForBids !== false
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_el_button, {
                          onClick: _ctx.startBidding,
                          type: "primary",
                          icon: "el-icon-position",
                          round: ""
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode(" Get this talent ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        (_ctx.opportunity)
                          ? (_openBlock(), _createBlock(_component_biddingCreateModal, {
                              key: 0,
                              hasAlreadyBidded: _ctx.hasAlreadyBidded,
                              talent: _ctx.talent,
                              opportunity: _ctx.opportunity
                            }, null, 8, ["hasAlreadyBidded", "talent", "opportunity"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined
      ]), 1024)
    ]),
    middle: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        (_ctx.talent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.talent.boost !== undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", {
                        class: "el-icon-top",
                        success: ""
                      }, null, -1)),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$filters.boost(_ctx.talent.boost)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_app_user_section, { style: {"border-top-left-radius":"0px !important","border-top-right-radius":"0px !important"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_app_user_top_profile, {
                    opportunity: _ctx.opportunity,
                    user: _ctx.talent
                  }, null, 8, ["opportunity", "user"])
                ]),
                _: 1
              }),
              _createVNode(_component_app_user_skills, { user: _ctx.talent }, null, 8, ["user"]),
              _createVNode(_component_app_user_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_app_user_education, {
                    isSelf: _ctx.isSelf,
                    user: _ctx.talent
                  }, null, 8, ["isSelf", "user"]),
                  _createVNode(_component_app_user_experience, {
                    isSelf: _ctx.isSelf,
                    user: _ctx.talent
                  }, null, 8, ["isSelf", "user"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    right: _withCtx(() => [
      _createVNode(_component_app_right_nav, null, {
        default: _withCtx(() => [
          _createVNode(_component_app_business_right_nav),
          _createVNode(_component_app_opportunities_list_nav)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}